var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsCardNoTranscations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M74.1,134.1c34.1,0,61.8-27.7,61.8-61.8s-27.7-61.8-61.8-61.8c-34.1,0-61.8,27.7-61.8,61.8 S40,134.1,74.1,134.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M16.4,129.1c-0.7,1.9,0.2,4,2,4.7c1.8,0.7,3.9-0.1,4.7-2c0.7-1.8-0.1-4-2-4.7 C19.2,126.4,17.1,127.3,16.4,129.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M126.9,17.3c0.7-1.9-0.2-4-2-4.7c-1.8-0.7-3.9,0.1-4.7,2c-0.7,1.8,0.1,4,2,4.7C124,20,126.2,19.2,126.9,17.3 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M10.8,122.3c-0.5,1.2,0.1,2.5,1.3,3c1.2,0.5,2.5-0.1,3-1.3c0.5-1.2-0.1-2.5-1.3-3 C12.6,120.6,11.2,121.1,10.8,122.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M132.5,24.1c0.5-1.2-0.1-2.5-1.3-3c-1.2-0.5-2.5,0.1-3,1.3c-0.5,1.2,0.1,2.5,1.3,3 C130.7,25.9,132,25.3,132.5,24.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.6856,
    y1: 69.6961,
    x2: 18.5339,
    y2: 80.755,
    gradientTransform: "matrix(1 0 0 -1 0 150)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4F0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F9FF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M18.5,23.5L81.4,6.5c4.3-1.2,8.8,1.4,10,5.8l27.9,104.6c1.2,4.4-1.4,8.9-5.8,10l-62.9,16.9 c-4.3,1.2-8.8-1.4-10-5.8L12.8,33.5C11.6,29.1,14.2,24.6,18.5,23.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.324,
    d: "M78.5,26.9L78.5,26.9c-0.6-0.3-1.4-0.1-1.7,0.5 c-0.3,0.6-0.1,1.3,0.4,1.7c2.6,1.5,4.4,4,5.2,6.9c0.7,2.9,0.3,6-1.2,8.6l0,0c-0.3,0.6-0.1,1.3,0.4,1.7c0.6,0.3,1.3,0.1,1.7-0.5 c1.9-3.2,2.4-6.9,1.5-10.4C83.9,31.7,81.6,28.7,78.5,26.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.324,
    d: "M73.9,31.1L73.9,31.1c-0.6-0.3-1.4-0.1-1.7,0.5 c-0.3,0.6-0.1,1.3,0.4,1.7c3.4,2,4.6,6.5,2.5,9.9l0,0c-0.3,0.6-0.1,1.3,0.4,1.7c0.6,0.3,1.3,0.1,1.7-0.5 C80,39.7,78.5,33.8,73.9,31.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.324,
    d: "M69.3,35.2L69.3,35.2c-0.6-0.3-1.3-0.1-1.7,0.5l0,0l0,0 c-0.3,0.6-0.1,1.3,0.4,1.7c1.5,0.9,2,2.8,1.1,4.4l0,0l0,0c-0.3,0.6-0.1,1.3,0.4,1.7c0.6,0.3,1.3,0.1,1.7-0.5 C72.9,40.3,72,36.8,69.3,35.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.8,94.6c0.4,1.6-0.5,3.2-2.1,3.6l-7.2,1.9c-1.6,0.4-3.2-0.5-3.6-2.1c-0.4-1.6,0.5-3.2,2.1-3.6l7.2-1.9 C46.7,92.1,48.4,93,48.8,94.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M65,90.2c0.4,1.6-0.4,3.2-2,3.6l-6.7,1.8c-1.5,0.4-3-0.5-3.5-2.1c-0.4-1.6,0.4-3.2,2-3.6l6.7-1.8 C63.1,87.7,64.6,88.6,65,90.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M82,85.6c0.4,1.6-0.5,3.2-2.1,3.6l-7.2,1.9c-1.6,0.4-3.2-0.5-3.6-2.1c-0.4-1.6,0.5-3.2,2.1-3.6l7.2-1.9 C80,83.1,81.6,84,82,85.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.4,107.1L84,93.2c4.3-1.2,8.8,1.4,10,5.8c1.2,4.3-1.4,8.8-5.8,10l-51.6,13.8L32.4,107.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsCardNoTranscations);
export default __webpack_public_path__ + "static/media/es-card-no-transcations.27342402133f083638c2834024d93a0c.svg";
export { ForwardRef as ReactComponent };